import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Injectable({
  providedIn: 'root'
})

export class PatientdashboardService {

  baseUrl = environment.baseUrl;
  accessToken = Cookie.get('token');
  // accessToken='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Mjk5LCJlbWFpbCI6ImJ2YW5lc2gxMzVAZ21haWwuY29tIiwibW9iaWxlTnVtYmVyIjoiODgzODk0MjUxMCIsImlhdCI6MTU5ODQ2MDgyM30.8lOYHkfv5kkl-BA4cGUx84Z-NHJuVfWiQZeStuYJCVw'
  constructor(private http: HttpClient) { }


  myBookings(apiData) {
    // console.log(apiData)
    // console.log(this.accessToken);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': this.accessToken,
      'role': 'user'
    });

    return this.http.post(this.baseUrl + '/user/myBookings', apiData, {

      headers: httpHeaders,
      observe: 'response'
    });
  }
  cancelBooking(apiData) {
    console.log(apiData)
    console.log(this.accessToken);
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': this.accessToken,
      'role': 'user'
    });

    return this.http.post(this.baseUrl + '/user/cancelBookings', apiData, {

      headers: httpHeaders,
      observe: 'response'
    });
  }
}